import { Component } from '@angular/core';
import { ModalController, NavParams, ViewController } from 'ionic-angular';
import { DailyWageSetService } from './../../services/dailywageset.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { AppConfig } from './../../app/app.config';
import { DailyWagesModel, DailyWagesRulesModel } from './../../models/dailywageset.model';
import * as $ from 'jquery';
/**
 * Generated class for the DailywagesetPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
    selector: 'page-adddailwages',
    templateUrl: 'adddailywages.html',
    providers: [
        DailyWageSetService,
    ]
})
export class AddDailyWagesPage {
    constructor(
        private dailywageset: DailyWageSetService,
        private loadding: LoaddingService,
        private modalCtrl: ModalController,
        private navpar: NavParams,
        private viewCtrl: ViewController,
        private alert: AlertService
    ) { }

    param = new information();
    username: string;
    MinSales;
    MaxSales;
    DailyWagesPercent;
    maxdailywages;
    ionViewDidLoad() {
        this.username = this.navpar.get("userName");
        // this.maxdailywages = this.navpar.get("maxdailywages");
        this.dailywageset.getDailyWageSetting().then(s=>{
            this.maxdailywages = s.Result.MaxDailyWagesPercent;
        });
    }

    sure() {
        this.param.UserName = this.username;
        this.dailywageset.addDailyWagesRules(this.param).then(s => {
            if (s.Result == true) {
                this.alert.showAlert(s.Error);
                this.viewCtrl.dismiss({ isOk: true });
            } else {
                this.alert.showAlert(s.Error);
            }

        });
    }
    cancel() {
        this.viewCtrl.dismiss();
    }
}
export class information {
    UserName: string;
    MinSales: number;
    MaxSales: number;
    DailyWagesPercent: number;
    MaxDailyWagesMoney: number;
}



// WEBPACK FOOTER //
// ./src/pages/dailywageset/adddailywages.ts